<template>
  <div class="text-blue-400">
    {{ calcedTime }}
  </div>
</template>

<script>
export default {
  name: "AddTimeRefresher",
  data() {
    return {
      interval: null,
      calcedTime: "",
    }
  },
  props: {
    date: Date,
  },
  mounted() {
    this.interval = setInterval(() => {
      this.calcTime()
    }, 1000)

    this.calcTime()
  },
  unmounted() {
    clearInterval(this.interval)
  },
  methods: {
    calcTime() {
      this.calcedTime = new Date().toLocaleTimeString("de-DE")
      // const itemDate = new Date(this.date)
      // let actDate = new Date()
      // actDate.setDate(itemDate.getDate())
      // actDate.setMonth(itemDate.getMonth())
      // actDate.setFullYear(itemDate.getFullYear())

      // const diff = actDate.getTime() - itemDate.getTime()
      // let msec = diff
      // const hh = Math.floor(msec / 1000 / 60 / 60)
      // msec += hh * 1000 * 60 * 60
      // const mm = Math.floor(msec / 1000 / 60)
      // msec += mm * 1000 * 60
      // const ss = Math.floor(msec / 1000)
      // msec += ss * 1000
      // this.calcedTime =
      //   hh.toString().padStart(2, "0") +
      //   ":" +
      //   mm.toString().padStart(2, "0") +
      //   ":" +
      //   ss.toString().padStart(2, "0")
    },
  },
}
</script>
